module.exports = __webpack_public_path__ + "img/labs2_3.62749fa1.svg";